import { render } from "./SupportTicketsSection.vue?vue&type=template&id=562269f6&scoped=true"
import script from "./SupportTicketsSection.vue?vue&type=script&lang=js"
export * from "./SupportTicketsSection.vue?vue&type=script&lang=js"

import "./SupportTicketsSection.vue?vue&type=style&index=0&id=562269f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562269f6"]])

export default __exports__